var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAircraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#pattern0_1758_3284)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1758_3284",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1758_3284",
    transform: "scale(0.0125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1758_3284",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAABmJLR0QA/wD/AP+gvaeTAAAD+0lEQVR4nO2avW8cZRCHn1nvGl+QZRAKJsRBCgUfFUV8MTEEQYVQqBA1f0cqIgpoKXEbF4iPiIIYgZQEiJJYttdCogUkpKAglAJiI2Ls9d5QZGPOB7ndu3nvC+ZpfLOe2fntT3e7o3dfcBzHcRzHcRzHcRzHcfqHNAeaJteAhtSzk23i+aaS30EvkI+dlme3v6/SUFdqM4xl74K8DEwGuYqwOq6WXP9eDBC1nLeBom3j/UyCvMZYY0WXa4erid79FuR1wpkXVkfZ9e+Pbehy7bCm40uaJqrryYel+Wn8saaJ6tr4+SoXOgo6pDylRMxa7Qiyex3YkHr2QNvcNNkEJsniGZnfumHtPQw6Wn/CHSPHt34qPk5VSJ8ECG3eIHWYDfy/4wYaMRuoa7UjxcffKqRvQPEUDMygdJgM1JXaDJIvFOEXFUo+B2AsXwhp4iB1dDNIN6SendQ0uQy8UFT+jCQnZHbrertmul57DM1XQA8Vhy5LPXuxk77DpAO6GaT/jpuOR9XGoUhb8+6eo5O+w6TDxr4BNk3eL81Pkw96Pkj3WUfIQfqW1LMH2+amyS1gqseDdF91hByk207/BVPQ80G6rzp8DjTiBhpxA424gUbcQCNuoBE30IgbaMQNNOIGGnEDjbiBRtxAI7Yl/dWJo5omi3txmizq6sTRbvNGUUfX64GaTjwO+TIw3XLKX2hE8zL354+d5I2qDsM3MH8HmEZliSyeIYtnQD4DfYQof7vzvNHUYfgGJjeBg82runurwspNOZ5Nd5I3qjos98CDsH9Vd29VWHi4i7yR1OFPYSNuoJG4OajwYvkK8HxIAZom4d6zGmjS0dMdqi1duWLQfNVQ2zsd/Xyx/m8UL7f1XnG/6JcOvwcacQONBDWwaY/eRtPhTejNnsBh0BHMwP179PRC038uAsH3BA6Ljk73By4DJ0rO+StRNCfHtn8A0NX7niBqLAMPhRJdkW51fC317CXozRjT7im2CXquWTSAzG1/RxY/g/ARxc+ox1h19HF/YJos3NlnF79ZvSY+U4wU7/0XdNjugY3GEgAir1YvKnKlqA3BAHXYDMzzS8BtYFa/OfBoWbqucwg4BmxB/pWp95DoMBko82yh8iUg5Nkr5RXJKUBAL8osty29/6EDvTQIHQHGGP0UUNDyn4/qKUBROW/v24osDUKH3UDNPgEE5LnyXJkHpKgJS5adK3SUrxYF1GE3MIqfAkB0pzRXdPfO3/hJc99Wkvjposd2P3WEWw/U6GxpN40WET2NyDVNE6P0e/aw6uhoPTBuKe58cBS9gUZnObDzVqnw+3fO8Mc4SOMNkNKnZUeE0jHo9UDHcRzHcRzHcRzHcRynDX8BEuCE/zgI2RYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAircraft);
export default __webpack_public_path__ + "static/media/aircraft.8a3c5ad5d4d3d56edd827901faf65e62.svg";
export { ForwardRef as ReactComponent };